/**
 * Shared hooks for opportunity DisplayV2 components
 *
 * These hooks extract common patterns from solicitation detail pages:
 * - Federal Contracts
 * - Federal Grants
 * - SBIR
 * - SLED Contracts
 * - Awards
 */

export { useTitleClasses } from './useTitleClasses'
export { useScrollHighlight } from './useScrollHighlight'
export { useNoticeScrollHighlight } from './useNoticeScrollHighlight'
export { useDaysRemaining } from './useDaysRemaining'
export {
  useFederalContractDiffs,
  useFederalGrantDiffs,
  useSledContractDiffs,
} from './useNoticeDiffs'
export type {
  FederalContractDiffs,
  FederalGrantDiffs,
  SledContractDiffs,
} from './useNoticeDiffs'
